<template>
  <section id="section-header" class="p-header">
    <div class="p-header__ctn">
      <p>OASIS 2: YOU 업데이트 기념 생방송</p>
      <h1>인사이드M 시즌4 : 오아시스 어드벤처</h1>
      <p>11. 28.(월) 20시 ON-AIR </p>
      <p>2022년 11월 30일, OASIS 2: YOU업데이트가 공개됩니다.
        이를 기념하여 즐길 거리가 가득한 환상의 오아시스 어드벤처로 용사님들을 초대합니다.
        MC 게임할가영, 용느 그리고 리니지M 인사이더들이 준비한
        새로운 업데이트 정보와 푸짐한 보상을 생방송으로 만나보세요.
      </p>
    </div>
    <a href="https://lineagem.plaync.com/update/2022/221116_update" class="p-header__menu--1"></a>
    <a href="https://lineagem.plaync.com/update/2022/221111_update" class="p-header__menu--2"></a>
<!--    <p class="p-header__date">2022년 11월 28일(월) 20시</p>-->
    <p class="p-header__date">{{param.header}}</p>
  </section>

  <section id="section-1" class="p-sec1">
    <div class="p-sec1__ctn">
      <h3>출연자 소개</h3>
      <p>
        힐링 크루 : BJ 게임할가영,
        찐텐 크루 : BJ 용느
        보상 크루, 개발 크루, 한방 크루
        리니지M 인사이더
      </p>
    </div>
  </section>

  <section id="section-2" class="p-sec2">
    <div class="p-sec2__con">
      <h3>방송 시청 및 참여 안내</h3>
      <p>
        2022년 11월 28일(월) 20시 ON-AIR
        방송이 시작되면 아래 버튼과 공식 홈페이지 내 링크 등을 통해 방송에 입장하실 수 있습니다.
        인사이드M 시즌4
        오아시스 어드벤처
        OASIS 2: YOU 업데이트 생방송
        오아시스 어드벤처에서 최초 공개되는 업데이트 정보와 푸짐한 보상을 획득하세요!
        ON AIR 방송 보기
      </p>
    </div>
<!--    <p class="p-sec2__date">2022년 11월 28일(월) 20시</p>-->
    <p class="p-sec2__date">{{param.section2}}</p>
<!--    <div class="p-sec2__broadcast" v-if="true">-->
    <div class="p-sec2__broadcast" v-if="param.broadcast?.state">
      <a :href="param.broadcast?.url" class="p-sec2__btn"></a>
    </div>
    <div class="p-sec2__broadcast disabled" v-else></div>
  </section>

  <section id="section-3" class="p-sec3">
    <div class="p-sec3__ctn">
      <h3>특별 생방송 선물 안내</h3>
      <p>생방송에 함께해 주시는 용사님들을 위하여 푸짐한 보상을 준비했습니다.</p>
    </div>
    <a href="https://lineagem.plaync.com/board/event/view?articleId=50215410" class="p-sec3__btn">자세히 보기</a>
  </section>
</template>
<script>
//import axios from 'axios';

export default {
  name: 'App',
  data() {
    return {
      param:window.Param
    };
  },
  components: {

  },
  methods: {
  },
  created(){
  },
  mounted() {
    promokit.page({
      el: '#container',
      type: 'basic',
      game: 'lineagem',
      cnb: true,
      topButton:true,
      footer:{
        theme:'black'
      },
      headerButton:{
        // cookie:{
        //   type:'year',
        //   key: 'INDEX_WEB_VISIT_lineagem_221123_oasis',
        //   value:false
        // },
        home:true,
        event:true,
        sns:true,
        theme:'black'
      },
      // caution:{
      //   template:
      //       `<ol>
      //       <li> 게임 이용 제한 계정은 이벤트 참여가 제한됩니다.</li>
      //   </ol>`
      // }
    });
  }
};
</script>

<style lang="scss">
@import "src/scss/pc.scss";


</style>
